import { render } from "./MMUpdateAssessment.vue?vue&type=template&id=347d5855"
import script from "./MMUpdateAssessment.vue?vue&type=script&lang=js"
export * from "./MMUpdateAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__